import { render, staticRenderFns } from "./EditDataList.vue?vue&type=template&id=3bac739f&scoped=true"
import script from "./EditDataList.vue?vue&type=script&lang=js"
export * from "./EditDataList.vue?vue&type=script&lang=js"
import style0 from "./EditDataList.vue?vue&type=style&index=0&id=3bac739f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac739f",
  null
  
)

export default component.exports